import fitmentSearchConfig from 'Models/uiConfig/fitmentSearchConfig.js';
import requestConfig from 'Models/uiConfig/requestConfig';
import { getCartUrls } from 'Platforms/shopify/helpers.ts';
import t from 'Utils/translate';

export default {
  getVerifyFitmentOrderNotes,
  onVehicleSelected,
  onVehicleDiscarded,
  onVerifyFitmentInitResponseReceived,
  onVerifyFitmentResponseReceived,
};

function onVehicleSelected(vehicle) {
  setVehicleAtCart(vehicle);
}

function onVehicleDiscarded() {
  resetVehicleAtCart();
}

function onVerifyFitmentInitResponseReceived(response) {
  setNotesOnCartItems(response);
  setVehicleInfoAtCart(response);
}

function onVerifyFitmentResponseReceived(response) {
  setNotesOnCartItems(response);
  setVehicleInfoAtCart(response);
}

function getVerifyFitmentOrderNotes(fits, vehicleString, fieldsToSpecify) {
  const translations = {
    yes: t('verify_fitment_notes_fits', { vehicleString }),
    no: t('verify_fitment_notes_does_not_fit', { vehicleString }),
    aggressive: t('verify_fitment_notes_aggressive_fits', { vehicleString }),
    universal: t('verify_fitment_notes_universal'),
    unknown: t('verify_fitment_notes_unknown'),
    specify: t('verify_fitment_notes_specify', { fieldsToSpecify, vehicleString }),
  };

  return translations[fits];
}

function setVehicleAtCart(vehicle) {
  const vehicleString = fitmentSearchConfig.fields
    .map((field) => vehicle[field])
    .filter(Boolean)
    .join(' ');

  const attributes = { ...vehicle, Vehicle: vehicleString };

  setCartAttributes(attributes);
}

function setVehicleInfoAtCart(response) {
  const vehicleInfoUrl = getVehicleInfoUrl(response);

  if (vehicleInfoUrl) {
    setCartAttributes({ __vehicleInfoUrl: vehicleInfoUrl });
  }
}

function resetVehicleAtCart() {
  const emptyVehicle = fitmentSearchConfig.fields.reduce((acc, cur) => ({ ...acc, [cur]: null }), {});

  const attributes = { ...emptyVehicle, Vehicle: null, __vehicleInfoUrl: null };

  setCartAttributes(attributes);
}

function getVehicleInfoUrl(response) {
  if (!response?.Extra?.WheelTireVehicleInfo) {
    return;
  }

  const vehicleInfoUrl = new URL(`https://${requestConfig.storeId}.myconvermax.com/ymm/vehicleinfo.html`);

  const vehicle = Object.fromEntries(
    response.Facets.filter((f) => fitmentSearchConfig.fields.includes(f.FieldName) && f.Selection.length).map(
      (f) => [f.FieldName, f.Selection[0].Value],
    ),
  );

  if (fitmentSearchConfig.baseFields.every((f) => vehicle[f])) {
    Object.entries(vehicle).forEach(([field, value]) => {
      vehicleInfoUrl.searchParams.set(field, value);
    });

    return vehicleInfoUrl.toString();
  }
}

function setCartAttributes(attributes) {
  fetch(`${getCartUrls().update}.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ attributes }),
  }).then((response) => {
    if (!response.ok) {
      console.error(response.json());
    }
  });
}

function setNotesOnCartItems({ Facets, Items }) {
  const forms = window.document.querySelectorAll('form[action^="/cart/add"]');

  if (!window?.Convermax.templates.config.fitmentSearchConfig.hideVerifyOnCartItems) {
    const fits = Items[0]?.fitsTheVehicle;

    if (forms && fits) {
      const selectedFields = fitmentSearchConfig.fields.map(
        (field) => Facets.find((f) => f.FieldName === field)?.Selection?.[0]?.Value,
      );

      const vehicleString = selectedFields.filter(Boolean).join(' ');

      if (vehicleString) {
        forms.forEach((form) => {
          const vehicleInput = form.querySelector('.cm_verify-message-property');

          if (vehicleInput) {
            vehicleInput.value = getVerifyFitmentOrderNotes(fits, vehicleString);
          } else {
            const input = document.createElement('input');
            input.className = 'cm_verify-message-property';
            input.type = 'hidden';
            input.name = 'properties[Fitment]';
            input.value = getVerifyFitmentOrderNotes(
              fits,
              vehicleString,
              fitmentSearchConfig.fields
                .filter((field) => !Facets.find((f) => f.FieldName === field))
                .join(', '),
            );

            // <input class="cm_verify-message-property" type="hidden" name="properties[Verify Message]" value="This product fit your 2024 Ford F-150">
            form.appendChild(input);
          }
        });
      }
    }
  }
}
